module.exports = __webpack_public_path__ + "img/level.8b3fdf43.png";